import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useAppDispatch } from 'shared/hooks/redux';

import { useGetProjectsQuery } from '../api/projects';
import { getMasterProjectIdForRoute } from '../model/projectTree';
import { clearSelectedProject, setSelectedProject, useSelectedProjectId } from '../model/selectedProject';

const PROJECT_ROUTE_PATTERN = /^\/project\/(\d+)(\/.*)?$/;

export const useSyncSelectedProjectFromRoute = (): void => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const selectedId = useSelectedProjectId();
  const { data: projects = [] } = useGetProjectsQuery();

  useEffect(() => {
    if (location.pathname === '/project') {
      if (selectedId !== null) {
        dispatch(clearSelectedProject());
      }
      return;
    }

    const match = location.pathname.match(PROJECT_ROUTE_PATTERN);
    if (!match || projects.length === 0) return;

    const projectId = Number(match[1]);
    if (!Number.isFinite(projectId)) return;

    const masterId = getMasterProjectIdForRoute(projects, projectId);
    if (masterId === null || masterId === selectedId) return;

    dispatch(setSelectedProject(masterId));
  }, [dispatch, location.pathname, projects, selectedId]);
};
